import React from 'react';
import { vatOf } from '../lib/vat';

const money = (v) => `₪${(parseFloat(v) || 0).toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const VatSummary = ({ subtotal, rate, noVat, onNoVatChange, testIdPrefix = 'vat' }) => {
  const vat = vatOf(subtotal, rate);
  return (
    <div className="w-full md:w-96 mr-auto bg-white border-2 border-slate-200 rounded-xl p-4 space-y-2 shadow-sm" data-testid={`${testIdPrefix}-summary`}>
      <label className="flex items-center gap-2 text-sm font-semibold text-gray-700 cursor-pointer select-none">
        <input type="checkbox" checked={noVat} onChange={(e) => onNoVatChange(e.target.checked)} className="w-4 h-4 accent-slate-700" data-testid={`${testIdPrefix}-no-vat-checkbox`} />
        ללא מע"מ
      </label>
      <div className="flex justify-between text-sm text-gray-600"><span>סה"כ לפני מע"מ</span><span data-testid={`${testIdPrefix}-subtotal`}>{money(subtotal)}</span></div>
      <div className="flex justify-between text-sm text-gray-600"><span>מע"מ {noVat ? '(פטור)' : `${rate}%`}</span><span data-testid={`${testIdPrefix}-amount`}>{money(vat)}</span></div>
      <div className="flex justify-between text-lg font-black text-slate-900 border-t pt-2"><span>סה"כ לתשלום</span><span data-testid={`${testIdPrefix}-total`}>{money((parseFloat(subtotal) || 0) + vat)}</span></div>
    </div>
  );
};
